module.exports = __webpack_public_path__ + "static/media/logo_bitcoin.983c87cd.png";